<template>
  <div>
    <el-header>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>发票管理</el-breadcrumb-item>
        <el-breadcrumb-item>申请发票</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <div style="background: #fff">
      <div class="title_box" style="">
        <span>发票抬头</span>
        <el-button type="primary" size="small" @click="selectBtn">{{
          companyInfo ? '重新选择' : '新增发票抬头'
        }}</el-button>
      </div>
      <template v-if="companyInfo">
        <el-row :gutter="20" style="padding: 0 20px">
          <el-col :span="10">企业名称：{{ companyInfo.enterpriseName }}</el-col>
          <el-col :span="10"
            >纳税人识别码：{{ companyInfo.taxPayerCode }}</el-col
          >
          <el-col :span="10">开户行：{{ companyInfo.bankName }}</el-col>
          <el-col :span="10">开户账号：{{ companyInfo.bankCode }}</el-col>

          <block v-if="isMoreShow">
            <el-col :span="10"
              >注册地址：{{ companyInfo.enterpriseFullRegAddr }}</el-col
            >
            <el-col :span="10"
              >单位电话：{{ companyInfo.enterpriseTelephone }}</el-col
            >
            <el-col :span="10">联系人姓名：{{ companyInfo.applicant }}</el-col>
            <el-col :span="10"
              >联系人手机号：{{ companyInfo.telephone }}</el-col
            >
            <el-col :span="10">电子邮箱：{{ companyInfo.mailbox }}</el-col>
            <!-- <el-col :span="10">联系地址：{{ companyInfo.applicantFullAddr }}</el-col> -->
          </block>
        </el-row>
        <div style="text-align: center; padding-top: 20px">
          <el-button type="text" @click="lookDetail">{{
            isMoreShow ? '收起' : '查看详情'
          }}</el-button>
          <i v-if="!isMoreShow" class="el-icon-arrow-down"></i
          ><i class="el-icon-arrow-up" v-else></i>
        </div>
      </template>
      <div v-else style="text-align: center; padding: 30px 0">
        没有企业抬头信息，请先新增企业抬头
      </div>
      <div class="title_box2" style="">
        <span>我的发票</span>
        <!-- <p>（注：浦发银行的保函去 <span>浦发网银</span> 开立发票）</p> -->
      </div>
      <div style="padding: 0 20px 20px 20px">
        <div style="display: flex; align-items: center; padding-bottom: 15px">
          <div style="flex: 1">
            <el-select size="small" v-model="status" placeholder="发票状态">
              <el-option
                v-for="item in statusList"
                :key="item.code"
                :label="item.description"
                :value="item.code"
              >
              </el-option>
            </el-select>
            <el-button
              style="margin-left: 20px"
              size="small"
              type="primary"
              @click="searchBtn"
              >筛 选</el-button
            >
          </div>
          <div style="float: right">
            已选中{{ selectRmbNum }}张代开订单，总金额{{ selectRmb }}元
            <el-button
              style="margin-left: 20px"
              @click="invoiceAddBtn"
              size="small"
              type="primary"
              :disabled="multipleSelection.length < 1"
              >开 票</el-button
            >
          </div>
        </div>
        <el-table
          :data="tableData"
          ref="multipleTable"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          border
        >
          <el-table-column
            type="selection"
            width="55"
            :selectable="selectable"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="date2"
            label="保函信息"
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              <div>项目名称：{{ scope.row.projectName }}</div>
              <div>保函编号：{{ scope.row.guaranteeId }}</div>
              <div>保函申请时间：{{ $parseTime(scope.row.created) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="totalMoney"
            width="150"
            label="开票金额（元）"
            header-align="center"
            align="left"
          ></el-table-column>
          <!-- <el-table-column prop="date4" label="出函机构">中国建设银行</el-table-column> -->
          <el-table-column
            prop="status"
            width="100"
            label="状态"
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.status === '03' ? '未开票' : '已开票' }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding-top: 20px">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getTitleList,
  getTitleDetail,
  getInvoiceList,
  getInvoiceListNew,
  getInvoiceStatus
} from '@/api/adminData/index'
export default {
  data() {
    return {
      guid: '',
      companyInfo: null,
      isMoreShow: false,
      region: '',
      multipleSelection: [], // 选择的数据
      tableData: [],
      total: 0,
      statusList: [
        {
          code: '03',
          description: '未开票'
        },
        {
          code: '06',
          description: '已开票'
        }
      ],
      currentPage: 1,
      pageSize: 10,
      status: '',
      selectRmb: 0,
      selectRmbNum: 0
    }
  },
  mounted() {
    this.guid = this.$route.query.guid
    if (this.guid) {
      this.getDetailData()
    } else {
      this.getListData()
    }
    this.getInvoiceListData()
    // this.getListStatus()
  },
  methods: {
    handleCurrentChange(v) {
      // 分页
      this.currentPage = v
      this.getInvoiceListData()
    },
    searchBtn() {
      // 筛选
      this.currentPage = 1
      this.getInvoiceListData()
    },
    getListData() {
      // 默认抬头
      this.contentLoading = true
      getTitleList({
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }).then((res) => {
        if (res.success) {
          // this.companyInfo = res.result.records[0]
          this.guid = res.result.records[0].guid
          this.getDetailData()
        }
        this.contentLoading = false
      })
    },
    getDetailData() {
      // 重新选择抬头
      this.contentLoading = true
      getTitleDetail({ guid: this.guid }).then((res) => {
        if (res.success) {
          this.companyInfo = res.result
        }
        this.contentLoading = false
      })
    },
    getInvoiceListData() {
      // 申请发票列表
      this.contentLoading = true
      getInvoiceListNew({
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        status: this.status
      }).then((res) => {
        if (res.success) {
          // res.result.records.forEach(item => {
          //   item.goodsList.forEach(e => {
          //     e.goodsContent = JSON.parse(e.goodsContent)
          //   })
          // })
          this.tableData = res.result.records
          this.total = res.result.total
        }
        this.contentLoading = false
      })
    },
    selectable(row, rowindex) {
      if (row.status != '03') {
        return false
      } else {
        return true
      }
    },
    handleSelectionChange(val) {
      // 选择
      this.multipleSelection = val
      // 选中的guid
      let guaranteeIds = val.map((element) => element.guaranteeId)
      guaranteeIds = guaranteeIds.toString()
      sessionStorage.setItem('guaranteeIds', guaranteeIds)
      // 选中的总金额
      const rmb = val.map((element) => element.totalMoney)
      this.selectRmbNum = rmb.length
      this.selectRmb = 0
      rmb.forEach((e) => {
        this.selectRmb += e
      })
      sessionStorage.setItem('invoiceMoney', this.selectRmb)
    },
    lookDetail() {
      // 查看详情
      this.isMoreShow = !this.isMoreShow
    },
    invoiceAddBtn(v) {
      // 开票
      this.$router.push({
        path: '/invoiceAdd',
        query: {
          guid: this.guid
        }
      })
    },
    selectBtn() {
      // 重新选择
      if (this.companyInfo) {
        this.$router.push({
          path: '/titleAdmin',
          query: {
            ifSelect: true
          }
        })
      } else {
        this.$router.push({
          path: '/titleAdd'
        })
      }
    },
    getListStatus() {
      // 发票状态
      getInvoiceStatus().then((res) => {
        if (res.success) {
          this.statusList = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.title_box {
  padding: 8px 20px;
  border-bottom: 1px solid #eee;
  font-weight: 700;
  display: flex;
  align-items: center;

  span {
    flex: 1;
  }

  button {
    float: right;
  }
}

.title_box2 {
  padding: 20px 20px;
  border-top: 1px solid #eee;
  font-weight: 700;
  display: flex;
  align-items: center;

  span {
    font-weight: bold;
  }

  p {
    font-weight: normal;
    padding-left: 10px;

    span {
      font-weight: bold !important;
    }
  }
}

.el-col-10 {
  padding-top: 20px;
}

i {
  color: #1890ff;
}
</style>
